import Supaprawat from "../../assets/Pannel Members/Supaprawat.jpg";
import Steven_Wagner from "../../assets/Pannel Members/Steven_Wagner.jpg";
import Mutlu from "../../assets/Pannel Members/Mutlu.jpg";
import Martin from "../../assets/Pannel Members/Martin.jpg";
import Leonie from "../../assets/Pannel Members/Leonie.jpg";
import Eman from "../../assets/Pannel Members/Eman.jpg";
import dr_martin from "../../assets/Pannel Members/dr_martin.jpg";
import AlKherayf from "../../assets/Pannel Members/AlKherayf.jpg";
import Ali from "../../assets/Pannel Members/Ali.jpg";

import Supaprawat_banner from "../../assets/Pannel Banners/Supaprawat_banner.jpg";
import Steven_Wagner_banner from "../../assets/Pannel Banners/Steven_Wagner_banner.jpg";
import Mutlu_banner from "../../assets/Pannel Banners/Mutlu_banner.jpg";
import Martin_banner from "../../assets/Pannel Banners/Martin_banner.jpg";
import Leonie_banner from "../../assets/Pannel Banners/Leonie_banner.jpg";
import Eman_banner from "../../assets/Pannel Banners/Eman_banner.jpg";
import dr_martin_banner from "../../assets/Pannel Banners/dr_martin_banner.jpg";
import AlKherayf_banner from "../../assets/Pannel Banners/AlKherayf_banner.jpg";
import Ali_banner from "../../assets/Pannel Banners/Ali_banner.jpg";

export const panel_members_about = [
  {
    id: "supaprawat",
    image: Supaprawat,
    banner: Supaprawat_banner,
    name: "Dr. Supaprawat",
    from: "Malaysia",
    about: "Adjunct Professor",
    link: "/executive-panel-members/supaprawat",
  },
  {
    id: "steven-wagner",
    image: Steven_Wagner,
    banner: Steven_Wagner_banner,
    name: "Dr. Steven Wagner",
    from: "USA",
    about: "Associate Professor",
    link: "/executive-panel-members/steven-wagner",
  },
  {
    id: "mutlu",
    image: Mutlu,
    banner: Mutlu_banner,
    name: "Prof. Mutlu Özcan",
    from: "Switzerland",
    about: "Professor",
    link: "/executive-panel-members/mutlu",
  },
  {
    id: "martin",
    image: Martin,
    banner: Martin_banner,
    name: "Dr. Martin Levine",
    from: "USA",
    about: "Associate Professor",
    link: "/executive-panel-members/martin",
  },
  {
    id: "leonie",
    image: Leonie,
    banner: Leonie_banner,
    name: "Leonie M. Short",
    from: "Australia",
    about: "Public Health Expert",
    link: "/executive-panel-members/leonie",
  },
  {
    id: "eman",
    image: Eman,
    banner: Eman_banner,
    name: "Dr. Eman Alsheikh",
    from: "Sudan",
    about: "Dental Specialist",
    link: "/executive-panel-members/eman",
  },
  {
    id: "dr-martin",
    image: dr_martin,
    banner: dr_martin_banner,
    name: "Prof. Dr. med. Martin Scholz",
    from: "Germany",
    about: "Senior Consultant",
    link: "/executive-panel-members/dr-martin",
  },
  {
    id: "alkherayf",
    image: AlKherayf,
    banner: AlKherayf_banner,
    name: "Dr. AlKherayf",
    from: "Canada",
    about: "Associate Professor",
    link: "/executive-panel-members/alkherayf",
  },
  {
    id: "ali",
    image: Ali,
    banner: Ali_banner,
    name: "Dr. Ali Nankali",
    from: "UK",
    about: "Clinical Reader",
    link: "/executive-panel-members/ali",
  },
];



export const panel_members = panel_members_about;

export const Supaprawat_data = {
  id: "supaprawat",
  image: Supaprawat,
  name: "Dr. Supaprawat Siripipatthanakul",
  from: "Malaysia",
  about: "Dr. Supaprawat Siripipatthanakul is an Adjunct Professor in Oral Medicine at Manipal GlobalNxt University in Malaysia. He holds multiple degrees, including a PhD (Ed), DBA, DDS, and MS in both Management and Oral Medicine. He is also a Faculty Member and Researcher at Manipal GlobalNxt University. Dr. Siripipatthanakul's professional affiliations extend to other institutions, including Bangkok Thonburi University and Universitas Terbuka, Indonesia, where he serves as a Visiting Professor.",
  banner: Supaprawat_banner,
  link: "/executive-panel-members/supaprawat",
};

export const Steven_Wagner_data = {
  id: "steven-wagner",
  image: Steven_Wagner,
  name: "Dr. Steven Wagner",
  from: "USA",
  about: "Dr. Steven Wagner earned his MS and PhD degrees in biochemistry from the University of Louisville, School of Medicine and did post-doctoral training in microbiology and molecular genetics at UC Irvine College of Medicine. He served as Director of Biochemistry at the Salk Institute Biotechnology/Industrial Associates, Inc., and was Chief Scientific Officer at Neurogenetics, Inc./TorreyPines Therapeutics, Inc. In 2009, he joined UC San Diego’s Department of Neurosciences, where he is currently an Associate Professor and Principal Investigator. His research focuses on developing therapeutic gamma-secretase modulators to prevent and delay the buildup of neuritic plaques in Alzheimer’s disease and Down syndrome.",
  banner: Steven_Wagner_banner,
  link: "/executive-panel-members/steven-wagner",
};

export const Mutlu_data = {
  id: "mutlu",
  image: Mutlu,
  name: "Prof. Mutlu Özcan",
  from: "Switzerland",
  about: "Prof. Mutlu Özcan is a globally renowned expert in reconstructive dentistry and translational research. She is affiliated with the University of Zurich and has authored over 500 scientific and clinical articles in peer-reviewed journals. She holds Honorary Professorships at institutions in Brazil, the USA, China, and more. Her roles include Honorary Secretary of the European Prosthodontic Association (EPA), Past-President of IADR/DMG, and Fellow of several prestigious dental associations. In 2018, she was awarded an honorary doctorate from Romania and the IADR Distinguished Scientist Wilmer Souder Award.",
  banner: Mutlu_banner,
  link: "/executive-panel-members/mutlu",
};

export const Martin_data = {
  id: "martin",
  image: Martin,
  name: "Dr. Martin Levine",
  from: "USA",
  about: "Dr. Martin Levine began his career with a BDS from the University of Glasgow and worked as a dentist in the UK NHS. He earned a BSc Honours in Biochemistry and a PhD from the University of Glasgow. He has held positions at SUNY Buffalo, University of Oklahoma, and served as an educator in the OU College of Dentistry. He continues as a volunteer faculty member, co-researching the genetic links in periodontitis and running PerioImm, a company working on a new genetic susceptibility test for periodontitis. He was honored with an innovation award at Semmelweis University.",
  banner: Martin_banner,
  link: "/executive-panel-members/martin",
};

export const Leonie_data = {
  id: "leonie",
  image: Leonie,
  name: "Leonie M. Short",
  from: "Australia",
  about: "Leonie M. Short is a Clinical Reader at the Queensland University of Technology and a registered dental therapist. She has helped launch multiple oral health degree programs across Australia and was elected to the Australian House of Representatives in 2001. She has served on the Australian Dental Council and the Australasian Council of Dental Schools. Leonie developed the OHTGYP curriculum and won several awards including participation in the SDL-7 Programme at Harvard. She actively contributes to oral health research, education, and professional development.",
  banner: Leonie_banner,
  link: "/executive-panel-members/leonie",
};

export const Eman_data = {
  id: "eman",
  image: Eman,
  name: "Dr. Eman Alsheikh",
  from: "Sudan",
  about: "Dr. Eman Alsheikh is a Dental Specialist and educator affiliated with the International University of Africa and University of Science and Technology in Sudan. She has strong experience in clinical teaching, dental research, and conducting lab-based studies. Known for her excellent mentorship and multilingual skills, she has guided both undergraduate and postgraduate students. Her focus is on contributing to oral medicine and clinical dentistry through research, teaching, and clinical service in higher education and healthcare systems.",
  banner: Eman_banner,
  link: "/executive-panel-members/eman",
};

export const dr_martin_data = {
  id: "dr-martin",
  image: dr_martin,
  name: "Prof. Dr. med. Martin Scholz",
  from: "Germany",
  about: "Prof. Dr. med. Martin Scholz is the Head of the Department of Neurosurgery and Neurosurgical Intensive Care at Sana Hospitals Duisburg, one of Germany’s largest neurosurgical centers. With over 35 years of experience, he specializes in microsurgery, neuroendoscopy, and spinal and pediatric neurosurgery. He holds multiple advanced certifications in neurosurgical subspecialties and works closely with departments like neurology, oncology, and pediatrics to deliver integrated care. He is recognized with numerous professional awards.",
  banner: dr_martin_banner,
  link: "/executive-panel-members/dr-martin",
};

export const AlKherayf_data = {
  id: "alkherayf",
  image: AlKherayf,
  name: "Dr. AlKherayf",
  from: "Canada",
  about: "Dr. AlKherayf is an Associate Professor and Residency Program Director in Neurosurgery at the University of Ottawa. He is also a Scientist at the Ottawa Hospital Research Institute and Director of Clinical Research at The Ottawa Hospital. With fellowship training in complex spine and skull base surgery, and a Master’s in Epidemiology, his research interests include primary brain tumor research, spinal cord injury, and clinical trials. He has authored numerous scientific papers and teaches in international neurosurgical education programs.",
  banner: AlKherayf_banner,
  link: "/executive-panel-members/alkherayf",
};

export const Ali_data = {
  id: "ali",
  image: Ali,
  name: "Dr. Ali Nankali",
  from: "UK",
  about: "Dr. Ali Nankali is a Clinical Reader in Digital Dentistry at Barts and The London School of Medicine and Dentistry. He has a PhD in Prosthodontics and a strong background in engineering, which informs his innovative research on masticatory force distribution and dental tissue resilience. He has invented multiple dental systems, mentored postgraduate and PhD students, and regularly leads CPD courses. Dr. Nankali has a well-established international reputation for his contributions to dental prosthetics and education.",
  banner: Ali_banner,
  link: "/executive-panel-members/ali",
};


export const epms_details_map = {
  supaprawat: Supaprawat_data,
  "steven-wagner": Steven_Wagner_data,
  mutlu: Mutlu_data,
  martin: Martin_data,
  leonie: Leonie_data,
  eman: Eman_data,
  "dr-martin": dr_martin_data,
  alkherayf: AlKherayf_data,
  ali: Ali_data,
};
